<section class="hero" #sliderSection>
    <div class="hero-left">
        <div class="slider">
            <div class="slide-track-left">
                <ng-container *ngFor="let property of (loopedProperties$ | async)">
                    <div class="slide">
                        <img [src]="property.image" [alt]="property.typeLabel" />
                        <div class="title-image">
                            {{ property.typeLabel }}<span *ngIf="property.badge"> en {{ property.badge.label }}</span>,
                            <strong>{{ property.location }}</strong>
                        </div>
                    </div>
                </ng-container>
            </div>

            <div class="slide-track-right">
                <ng-container *ngFor="let property of (loopedProperties$ | async)">
                    <div class="slide">
                        <img [src]="property.image" [alt]="property.typeLabel" />
                        <div class="title-image">
                            {{ property.typeLabel }}<span *ngIf="property.badge"> en {{ property.badge.label }}</span>,
                            <strong>{{ property.location }}</strong>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="hero-right">
        <div class="hero-content">
            <h1>Aquí está lo que <br> estabas buscando.</h1>
            <div class="col-12">
                <button pButton pRipple type="button" (click)="toggleDialog(true)">
                    <i class="pi pi-circle-fill custom-circle-fill-icon"></i>
                    <span class="px-3">Buscar una propiedad</span>
                    <i class="pi pi-arrow-right custom-arrow-right-icon"></i>
                </button>
            </div>
            <div class="col-12">
                <button pButton pRipple class="p-button-secondary" [routerLink]="'/welcome'">
                    <i class="pi pi-circle-fill custom-circle-fill-icon"></i>
                    <span class="px-3">Ofrecer una propiedad</span>
                    <i class="pi pi-arrow-right custom-arrow-right-icon"></i>
                </button>
            </div>
            <div class="col-12" *ngIf="isUserLoggedIn">
                <button pButton pRipple class="p-button-info" [routerLink]="'/list'">
                    <i class="pi pi-circle-fill custom-circle-fill-icon"></i>
                    <span class="px-3">Ver mis propiedades</span>
                    <i class="pi pi-arrow-right custom-arrow-right-icon"></i>
                </button>
            </div>
        </div>
    </div>
</section>
<ng-template [ngIf]="isSearchDialogVisible">
    <app-rc-search-property
        [showDialogSearch]="isSearchDialogVisible"
        (closeDialogSearch)="handleDialogClose($event)">
    </app-rc-search-property>
</ng-template>
